// components/form/PhoneInput.tsx
import React from 'react'
import {useField, useFormikContext, FieldHookConfig} from 'formik'
import InputMask from 'react-input-mask'

type PhoneInputProps = FieldHookConfig<string> & {
  label?: string
  wrapperClassName?: string
  readOnly?: boolean
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  label,
  wrapperClassName = '',
  readOnly = false,
  ...props
}) => {
  const [field, meta] = useField(props)
  const {submitCount} = useFormikContext()
  const showError = Boolean(meta.error && (meta.touched || submitCount > 0))

  return (
    <div className={wrapperClassName}>
      <div style={{height: label ? undefined : 0, overflow: 'hidden'}}>
        {label && <label className='form-label fw-bold'>{label}</label>}
      </div>

      {/* has-validation + invalid-feedback input-group içinde: BS5 .form-control.is-invalid ~ .invalid-feedback eşleşsin */}
      <div className='input-group has-validation'>
        <span className='input-group-text'>+90</span>
        <InputMask
          {...field}
          mask='9999999999'
          maskChar=''
          inputMode='numeric'
          className={['form-control', showError && 'is-invalid'].filter(Boolean).join(' ')}
          readOnly={readOnly}
        />
        {showError && (
          <div className='invalid-feedback d-block' role='alert'>
            {meta.error}
          </div>
        )}
      </div>
    </div>
  )
}

export default PhoneInput
